import {
  Box,
  Grid,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  MenuItem,
  Button,
  Card,
  CardContent
} from "@mui/material";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
import WSRadioField from "../../Components/Radio/WSRadio";
import {
  HeaderList,
  IHeaderListActions
} from "../../Components/Header/HeaderList";
import { Header } from "../../Components/Header/Header";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import React, { useEffect, useState } from "react";
import WSDateField from "../../Components/DateField/WSDateField";
import WSPhone from "../../Components/Phone/WSPhone";
import { callAPI, customValidation, EPhone, formatPhoneNumber, Method, validations } from "../../commonFunctions/CommonFunctions";
import WSSelectField from "../../Components/Select/WSSelect";
import clientConfig from '../../Config/clientConfig.json'
import config from '../../Config/config.json'
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../commonFunctions/httpClient";
export const SolarSiteSurveyForm: React.FC<any> = React.memo(() => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [loading, setLoading] = useState(false);
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState<any>([]);
  const [imageUrl, setImageUrl] = useState<any>();
  const { showMessage } = useSnackbar();
  const navigate = useNavigate();
  const params = useParams();
  const id: any = params?.id;
  const handleCancelClick = () => {navigate('/survey/list') };
  const handleDataSaveAndNew = () => { };

  useEffect(() => {
    /**
     * Method to get the user record by id for edit purpose
     * @param id
     */
    async function getSurveyById(id: any): Promise<void> {
      try {

        const response: any = await http.get(`Site-Survey-Form/${id}`); //callAPI
        if (response && response.data) {
          setValue("consumerNumber", response?.data?.consumerNumber);
          setValue("customerName", response?.data?.customerName);
          setValue("date", response?.data?.date);
          setValue("customerAddress", response?.data?.customerAddress);
          setValue("mobile", formatPhoneNumber(response?.data?.mobile, EPhone.RemoveHyphen));
          setValue("registeredCapacity", response?.data?.registeredCapacity);
          setValue("isSinglePhase", response?.data?.isSinglePhase);
          setValue("isThreePhase", response?.data?.isThreePhase);
          setValue("email", response?.data.email);
          setValue("village", response?.data?.village);
          setValue("solarPanel", response?.data?.solarPanel);
          setValue("block", response?.data?.block);
          setValue("numberOfPanels", response?.data?.numberOfPanels);
          setValue("inverter", response?.data?.inverter);
          setValue("inverterCapacity", response?.data?.inverterCapacity);
          setValue("accessToRooftop", response?.data?.accessToRooftop);
          setValue("ladderType", response?.data.ladderType);
          setValue("roofType", response?.data?.roofType);
          setValue("additionalStructure", response?.data?.additionalStructure);
          setValue("buildingHeight", response?.data?.buildingHeight);
          setValue("cableAC", response?.data?.cableAC);
          setValue("cableDC", response?.data.cableDC);
          setValue("cableLA", response?.data?.cableLA);
          setValue("earthNos", response?.data?.earthNos);
          setValue("structureDetails", response?.data?.structureDetails);
          setValue("customerAmountPayable", response?.data?.customerAmountPayable);
          setValue("advanceReceived", response?.data?.advanceReceived);
          setValue("balanceAmount", response?.data?.balanceAmount);
          setValue("panchayatMunicipality", response?.data?.panchayatMunicipality);
          if (
            response?.data?.customerSignature

          )
            if (response?.data?.customerSignature) {
              setImageUrl(
                `${config.imgUrl}${response?.data?.customerSignature.replace(
                  "UploadedImages/",
                  ""
                )}`
              );
            }

        }
      } catch (error) {
        showMessage("Error fetching vendor:", "error");
      }
    }
    if (id) {
      getSurveyById(id);
    }
  }, [id]);
  const handleData = async (data: any) => {
    try {
      setLoading(true);
      const request: any = await setRequest(data);
      if (id) {
        const response: any = await callAPI(
          `Site-Survey-Form/${id}`,
          Method.PUTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          if (response.success === true) {
            showMessage(
              response?.message,
              response.success === true ? "success" : "error"
            );
            response.success === true && navigate(`/survey/list`);
          }
        }
      } else {
        const response: any = await callAPI(
          "Site-Survey-Form",
          Method.POSTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          if (response.success === true) {
            showMessage(
              response?.message,
              response.success === true ? "success" : "error"
            );
            response.success === true && navigate(`/survey/list`);
          }
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };
  const actions: IHeaderListActions[] = [
    {
      type: "button",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "primary"
    },
    // {
    //   type: "button",
    //   text: "Save & New",
    //   loading: loadingSaveAndNew,
    //   size: "small",
    //   onClick: handleSubmit(handleDataSaveAndNew),
    //   buttonType: "button",
    //   variant: "outlined",
    //   color: "primary"
    // },
    {
      type: "button",
      text: "Save",
      loading: loading,
      size: "small",
      onClick: handleSubmit(handleData),
      buttonType: "submit",
      variant: "outlined",
      color: "primary"
    }
  ];
  const handleUploadFile = (file: any) => {
    // setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedDocuments(file);
      setImageUrl(file[0])
    }
  };


  const setRequest = async (data: any) => {
    try {

      const formData = new FormData();

      if (selectedDocuments) {
        for (const file of selectedDocuments) {
          formData.append("customerSignature", file);
        }
      }

      formData.append("consumerNumber", data?.consumerNumber);
      formData.append("customerName", data?.customerName);
      formData.append("date", data?.date);
      formData.append("customerAddress", data?.customerAddress);
      formData.append("mobile", formatPhoneNumber(data?.mobile, EPhone.RemoveHyphen));
      formData.append("registeredCapacity", data?.registeredCapacity);
      formData.append("isSinglePhase", data?.isSinglePhase);
      formData.append("isThreePhase", data?.isThreePhase);
      formData.append("email", data.email);
      formData.append("village", data?.village);
      formData.append("solarPanel", data?.solarPanel);
      formData.append("block", data?.block);
      formData.append("numberOfPanels", data?.numberOfPanels);
      formData.append("inverter", data?.inverter);
      formData.append("inverterCapacity", data?.inverterCapacity);
      formData.append("accessToRooftop", data?.accessToRooftop);
      formData.append("ladderType", data.ladderType);
      formData.append("roofType", data?.roofType);
      formData.append("additionalStructure", data?.additionalStructure);
      formData.append("buildingHeight", data?.buildingHeight);
      formData.append("cableAC", data?.cableAC);
      formData.append("cableDC", data.cableDC);
      formData.append("cableLA", data?.cableLA);
      formData.append("earthNos", data?.earthNos);
      formData.append("structureDetails", data?.structureDetails);
      formData.append("customerAmountPayable", data?.customerAmountPayable);
      formData.append("advanceReceived", data?.advanceReceived);
      formData.append("balanceAmount", data?.balanceAmount);
      formData.append("panchayatMunicipality", data?.panchayatMunicipality);

      return formData;
    } catch (e: any) {
      //  showMessage(e.error);
    }
  };
  return (
    <>
      <HeaderList
        title={!id?"Add Survey":"Update Servey"}
        type="card"
        position="sticky"
        actions={actions}
        isBackButton={true}
        url="/survey/list"
      />
      <Card sx={{
        borderRadius: "10px",
        padding: 3,
        marginTop: "0px",

      }}>
        <CardContent>
          <Grid container spacing={3} top={0}>
            <form >
              <Grid container spacing={2}>
                {/* Customer Details */}
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '0.875rem' }}>Customer Details</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Consumer Number" /> */}
                  <WSTextField
                    id="consumerNumber"
                    label="Consumer Number"
                    name="consumerNumber"
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} md={6}>

                  <WSDateField
                    id="date"
                    label="Date"
                    name="date"
                    rules={{ required: false }}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <WSTextField
                    id="customerName"
                    label="Customer Name"
                    name="customerName"
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Customer Name & Address" /> */}
                  <WSTextField
                    id="customerAddress"
                    label="Address"
                    name="customerAddress"
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Mobile" /> */}
                  <WSPhone
                    id="mobile"
                    label="Mobile"
                    name="mobile"
                    rules={{ required: false }}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    control={control}
                    className="form-control"
                    id="email"
                    rules={customValidation(false, validations.email)}
                    name="email"
                    label="Email"
                  />
                </Grid>
                {/* Customer Requirements */}
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '0.875rem' }}>Customer Requirements</Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Registered Capacity" /> */}
                  <WSTextField
                    id="registeredCapacity"
                    label="Registered Capacity"
                    name="registeredCapacity"
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Village" /> */}
                  <WSTextField
                    label={"Village *"}
                    id="village"
                    name="village"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Panchayat / Municipality" /> */}
                  <WSSelectField
                    label={"Panchayat / Municipality *"}
                    id="panchayatMunicipality"
                    name="panchayatMunicipality"
                    control={control}
                    rules={{ required: false }}
                    options={clientConfig.PanchayatTypeSourceConfig.staticOptionData}
                  />
                </Grid>



                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Block" /> */}
                  <WSTextField
                    label={"Block *"}
                    id="block"
                    name="block"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Solar Panel" /> */}
                  <WSTextField
                    label={"Solar Panel *"}
                    id="solarPanel"
                    name="solarPanel"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="No. of Panels" /> */}
                  <WSTextField
                    label={"No. of Panels *"}
                    id="numberOfPanels"
                    name="numberOfPanels"
                    type={TextType.AllowOnlyNumber}
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Inverter" /> */}
                  <WSTextField
                    label={"Inverter *"}
                    id="inverter"
                    name="inverter"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <TextField fullWidth label="Capacity" /> */}
                  <WSTextField
                    label={"Capacity *"}
                    id="inverterCapacity"
                    name="inverterCapacity"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>


                <Grid item xs={12} md={6}>
                  <WSSelectField control={control} id="ladderType" name="ladderType" label={'Ladder Type'} options={clientConfig.ladderTypeSourceConfig.staticOptionData} />

                </Grid>

                <Grid item xs={12} sm={6}>

                  <WSTextField
                    label={"Roof Type *"}
                    id="roofType"
                    name="roofType"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <WSTextField control={control} id="buildingHeight" name="buildingHeight" label={'Building Height'} />
                </Grid>
                <Grid item xs={12} md={6}>
                  {/* <FormControlLabel control={<Checkbox />} label="Access to rooftop" /> */}
                  <WSSCheckBoxField
                    label={"Access to Roof Top *"}
                    id="accessToRooftop"
                    name="accessToRooftop"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <WSSCheckBoxField
                    label={"Additional Structure Required *"}
                    id="additionalStructure"
                    name="additionalStructure"
                    control={control}
                    rules={{ required: false }}
                  />

                </Grid>



                <Grid item xs={12} md={6}>
                  <WSSCheckBoxField control={control} id="isSinglePhase" name="isSinglePhase" rules={{ required: false }} label="Is Single Phase" />

                </Grid>
                <Grid item xs={12} md={6}>
                  <WSSCheckBoxField control={control} id="isThreePhase" name="isThreePhase" rules={{ required: false }} label="Is Three Phase" />

                </Grid>
                {/* Cable Requirement */}
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '0.875rem' }}>Cable Requirement (in meters)</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <WSTextField type={TextType.AllowOnlyNumber} control={control} id="cableAC" name="cableAC" label={'Cable AC'} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <WSTextField type={TextType.AllowOnlyNumber} control={control} id="cableDC" name="cableDC" label={'Cable DC'} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <WSTextField type={TextType.AllowOnlyNumber} control={control} id="cableLA" name="cableLA" label={'Cable LA'} />
                </Grid>
                <Grid item xs={6} md={6}>
                  {/* <TextField fullWidth label="Earth Cable (No's)" /> */}
                  <WSTextField
                    label={"Earth Cable (No's) *"}
                    id="earthNos"
                    name="earthNos"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>

                {/* Structure details */}
                <Grid item xs={12}>
                  {/* <TextField fullWidth multiline rows={2} label="Structure Details" /> */}
                  <WSTextField
                    label={"Structure Details *"}
                    id="structureDetails"
                    name="structureDetails"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>

                {/* Payment */}
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: '0.875rem' }}>Customer Payment Details</Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  {/* <TextField fullWidth label="Amount Payable" /> */}
                  <WSTextField
                    label={"Amount Payable *"}
                    id="customerAmountPayable"
                    name="customerAmountPayable"
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  {/* <TextField fullWidth label="Advance Received" /> */}
                  <WSTextField
                    label={"Advance Received *"}
                    id="advanceReceived"
                    name="advanceReceived"
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  {/* <TextField fullWidth label="Balance Payable" /> */}
                  <WSTextField
                    label={"Balance Amount *"}
                    id="balanceAmount"
                    name="balanceAmount"
                    control={control}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                    rules={{ required: false }}
                  />
                </Grid>

                {/* Signature */}

                <Grid item sm={6} style={{ overflow: "auto" }}>
                  <WSFileUpload
                    name="customerSignature"
                    label="Image"
                    control={control}
                    rules={{ required: false }}
                    acceptFileTypes=".jpg,.jpeg,.png"
                    maxFileSizeMB={2}
                    //  defaultValue={defaultImg}
                    id={"customerSignature"}
                    image={true}
                    onChange={handleUploadFile}
                    // onRemove={handleRemoveFile}
                    align="Start"
                    isToolTipImg={false}
                    multiple={false}
                   // imgUrl={imageUrl}
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>
        </CardContent>

      </Card>
    </>
  );
});


